import { alpha } from '@mui/material/styles';

export const pageContainerStyles = {
  wrapper: {
    minHeight: 'calc(100vh - 80px)', // Header height'ı çıkarıyoruz
    background: theme =>
      theme.palette.mode === 'dark'
        ? `linear-gradient(135deg, ${theme.palette.grey[900]} 0%, ${theme.palette.grey[800]} 100%)`
        : `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(theme.palette.secondary.light, 0.1)} 100%)`,
    px: 2,
    pb: { xs: 3, sm: 4 }, // Mobilde alta padding
  },

  container: {
    bgcolor: 'background.paper',
    borderRadius: '12px',
    boxShadow: theme =>
      theme.palette.mode === 'dark'
        ? '0 8px 32px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.2)' // Dark mode'da daha güçlü gölge
        : '0 4px 12px rgba(0, 0, 0, 0.15)', // Light mode'da hafif gölge
    overflow: 'hidden',
    minHeight: { xs: '400px', sm: '600px' }, // Mobilde minHeight azaltıldı
  },

  breadcrumbContainer: {
    px: 3,
    py: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  breadcrumbText: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'text.secondary',
  },

  breadcrumbSeparator: {
    mx: 1,
    color: 'grey.400',
    fontSize: '0.875rem',
  },

  breadcrumbCurrent: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: 'primary.main',
  },
};
